











import { Component, Vue, Watch } from 'nuxt-property-decorator';

/**
 * Mobile iOS browser has a bug with fixed/sticky elements on page's bottom with opened virtual keyboard.
 * VKeyboard doesn't change height of a viewport -> fixed element hides under keyboard.
 * Video of a bug https://bravado-network.atlassian.net/browse/GROW-474
 *
 * That module set `position: static` for element in slot#fixed when virtual keyboard is opened.
 *
 * Usage:
 * - pass content to default slot
 * - pass fixed element to fixed slot, fixed styles should be added manually by class or whatever
 * Effect will be visible only on iOS
 *
 * Another implementation idea:
 * set `position: absolute` and move element to keyboard height, but as iOS has different
 * keyboard heights over versions/screen position + custom keyboard, so that's not a bulletproof
 *
 * Details:
 * https://gist.github.com/AlexanderOMara/8747f59b6450878e78c7
 * https://gist.github.com/avesus/957889b4941239490c6c441adbe32398
 */
@Component
export default class MobileFixed extends Vue {
  withVirtualKeyboard = false;
  enabled = this.$device.isMobile && this.$device.isIos;
  hideTimer!: NodeJS.Timeout;

  mounted() {
    if (!this.enabled) return;
    // How to access elements in a slot directly? to avoid excess refs
    // this.$scopedSlots.default() returns Vnode, but not html elements
    // https://forum.vuejs.org/t/how-to-properly-access-components-inside-slot-content/4713/6
    const contentElements = this.$refs.content as HTMLElement;
    const inputElements = contentElements.querySelectorAll('input[type=text], input[type=search], select, textarea')!;

    inputElements.forEach(element => {
      element.addEventListener('touchstart', this.toggleVirtualKeyboard(true));
      element.addEventListener('focus', this.toggleVirtualKeyboard(true));
      element.addEventListener('blur', this.toggleVirtualKeyboard(false));
    });
  }

  toggleVirtualKeyboard(state: boolean) {
    return () => {
      this.withVirtualKeyboard = state;
    };
  }

  @Watch('withVirtualKeyboard')
  handleVirtualKeyboardToogled(withVirtualKeyboard: boolean) {
    clearTimeout(this.hideTimer);
    const fixedSlot = this.$refs.fixed as HTMLElement;
    // First child in fixed slot must be a element with position: fixed
    const fixedElement = fixedSlot.children?.[0] as HTMLElement;
    if (!fixedElement) return;

    if (withVirtualKeyboard) {
      fixedElement.style.position = 'static';
    } else {
      // If user click to element on fixed -> input blurs and element will move
      // so wait till recieve all clicks on element
      this.hideTimer = setTimeout(() => {
        fixedElement.style.position = '';
      }, 50);
    }
  }
}
